// Tournament constants — DÉFI ULTIME
// LOGO_URL = transparent processed logo (white background removed) served from public/
// LOGO_URL_SOCIAL = original logo on Emergent CDN (used for OG meta + favicon)
export const LOGO_URL = "/logo-transparent.png";

export const SOCIAL = {
    facebook: "https://www.facebook.com/share/g/1EViwLi78H/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/defiultime?igsh=NmF4OGtwZzRwNDN5&utm_source=qr",
};
export const LOGO_URL_SOCIAL = "https://customer-assets.emergentagent.com/job_youth-ice-league/artifacts/g8aespvu_56AEE9D5-C72D-464D-905D-1783BD5E49D1.png";
export const HERO_PLAYERS_PHOTO = "https://customer-assets.emergentagent.com/job_youth-ice-league/artifacts/rld0mipq_IMG_5956.jpeg";

export const TOURNAMENT = {
    name: "DÉFI ULTIME",
    edition: "Édition 2026",
    dates: "4 juillet 2026",
    arena: "Dek Hockey Cowansville",
    address: "200 Rue Christophe-Colomb, Cowansville, QC J2K 1G7",
    ices: ["Rocheleau", "Berard Tremblay"],
    categories: ["M13", "M15", "M18"],
    sport: "Dek hockey",
    registrationFee: 500,
    currency: "CAD",
};

// Birth years allowed per category
export const CATEGORY_YEARS = {
    "M13": "2013-2014",
    "M15": "2011-2012",
    "M18": "2008-2009-2010",
};

// Helper to display "M11 Open (2015-2016)"
export const categoryLabel = (cat) => {
    const years = CATEGORY_YEARS[cat];
    return years ? `${cat} (${years})` : cat;
};

export const HERO_IMAGES = [
    "https://images.unsplash.com/photo-1608980125376-d72052af1180?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1706841151550-e1fddbc253b0?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1714979545809-f131bcea85d8?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1616041042832-24ee0dff18d4?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1556768065-b75665902e94?crop=entropy&cs=srgb&fm=jpg&q=85",
];

export const formatDay = (d) => {
    if (!d) return "";
    try {
        const dt = new Date(d + "T00:00:00");
        return dt.toLocaleDateString("fr-CA", { weekday: "long", day: "numeric", month: "long" });
    } catch {
        return d;
    }
};

export const STATUS_LABELS = {
    scheduled: "À venir",
    live: "EN DIRECT",
    final: "Final",
};


// Phase labels (FR/EN) for game phase shown in /horaire and /match
export const PHASE_LABELS = {
    fr: {
        preliminaire: "Préliminaire",
        quart: "Quart-finale",
        demi: "Demi-finale",
        finale_d2: "Finale D2",
        finale_d3: "Finale D3",
        finale: "Finale",
        elim: "Éliminatoire",
    },
    en: {
        preliminaire: "Round-robin",
        quart: "Quarter-final",
        demi: "Semi-final",
        finale_d2: "Final D2",
        finale_d3: "Final D3",
        finale: "Final",
        elim: "Playoff",
    },
};

export const phaseLabel = (phase, lang = "fr") => {
    const dict = PHASE_LABELS[lang] || PHASE_LABELS.fr;
    return dict[phase] || phase || "";
};
